var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBnb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 164 164",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4594_7882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.1219 82.4298L54.1666 98.8427L68.1126 107.049V116.658L46.005 103.692V77.6303L54.1219 82.4298ZM54.1219 66.0169V75.5812L46 70.7767V61.2125L54.1219 56.408L62.2835 61.2125L54.1219 66.0169ZM73.9367 61.2125L82.0585 56.408L90.2202 61.2125L82.0585 66.0169L73.9367 61.2125Z",
    fill: "url(#paint0_linear_4594_7882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9902 95.4407V85.8317L68.1121 90.6362V100.2L59.9902 95.4407ZM73.9362 110.491L82.0581 115.295L90.2197 110.491V120.055L82.0581 124.86L73.9362 120.055V110.491ZM101.868 61.2125L109.99 56.408L118.151 61.2125V70.7767L109.99 75.5812V66.0169L101.868 61.2125ZM109.99 98.8426L110.035 82.4298L118.156 77.6253V103.687L96.0488 116.653V107.044L109.99 98.8426Z",
    fill: "url(#paint1_linear_4594_7882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.167 95.441L96.0449 100.201V90.6365L104.167 85.832V95.441Z",
    fill: "url(#paint2_linear_4594_7882)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.166 69.4188L104.21 79.0278L90.2247 87.2342V103.687L82.1028 108.447L73.9809 103.687V87.2342L59.9952 79.0278V69.4188L68.1519 64.6143L82.0531 72.8605L96.0388 64.6143L104.2 69.4188H104.166ZM59.9902 53.0109L82.0581 40L104.166 53.0109L96.0438 57.8154L82.0581 49.5692L68.1121 57.8154L59.9902 53.0109Z",
    fill: "url(#paint3_linear_4594_7882)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4594_7882",
    x: 38,
    y: 36,
    width: 88.1562,
    height: 100.859,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.941176 0 0 0 0 0.635294 0 0 0 0 0.0431373 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4594_7882"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4594_7882",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4594_7882",
    x1: 68.1101,
    y1: 56.408,
    x2: 68.1101,
    y2: 116.658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0870B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4594_7882",
    x1: 89.0733,
    y1: 56.408,
    x2: 89.0733,
    y2: 124.86,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0870B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4594_7882",
    x1: 100.106,
    y1: 85.832,
    x2: 100.106,
    y2: 100.201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0870B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4594_7882",
    x1: 82.1003,
    y1: 40,
    x2: 82.1003,
    y2: 108.447,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B90B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0870B"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnb);
export default __webpack_public_path__ + "static/media/bnb.23aa1f5dd50c0009e298a1e110cbe289.svg";
export { ForwardRef as ReactComponent };